<template>
  <div class="item-rent" @click="goDetail">
    <div class="img" v-lazy:background-image="$processImage(img,{resize:'mid'})">
      <!--       <span class="status" :class="['status' + rentStatus]" v-if="rentStatus === 1">{{ $t('entireRent') }}</span>
      <span class="status" :class="['status' + rentStatus]" v-if="rentStatus === 2">{{ $t('masterBedroomRent') }}</span>
      整套可分租
      <span class="status" :class="['status' + rentStatus]" v-if="rentStatus === 3">{{ $t('privateRoomRent') }}</span>
      <span class="status status-house-type" v-if="roomNum.length">{{roomNum[0]}}</b>Bedroom | {{roomNum[1]}}</b>Bathroom</span> -->
    </div>
    <div class="addr">{{ rentInfo.address }}</div>
    <div class="price smalltext" v-if="rentStatus === 3">
      <span>{{ $t('list.entire') }} {{ rentInfo.currency | currencySymbol }}{{ $formatMoney(rentInfo.price) }}/{{
        rentInfo.payPeriod | periodShort
        }}</span>
      <span v-for="singlePrice in rentInfo.roomList" :key="singlePrice.name" class="capitalize">{{ singlePrice.name }} {{ rentInfo.currency | currencySymbol }}{{ $formatMoney(singlePrice.price) }}</span>
    </div>
    <div class="price" v-else>
      <span class="font-bold letter-spacing">{{ rentInfo.currency | currencySymbol }}{{$formatMoney(rentInfo.price)}}</span>
      <small> / {{ rentInfo.payPeriod | periodShort }}</small>
    </div>
    <div class="name">
      <span>
        <font-icon :id="icon" :key="icon" v-for="icon in rentInfo.titleIcon" class="font-color"></font-icon>
      </span>
      {{ rentInfo.title }}
    </div>
    <div class="detail">
      <span v-if="rentInfo.houseTypeArray[0]">{{rentInfo.houseTypeArray[0]}}</b> Beds</span>
      <span v-if="rentInfo.houseTypeArray[1]">{{rentInfo.houseTypeArray[1]}}</b> Baths</span>
      <span v-if="rentStatus === 1">{{ $t('entireRent') }}</span>
      <span v-if="rentStatus === 2">{{ $t('masterBedroomRent') }}</span>
      <span v-if="rentStatus === 3">{{ $t('privateRoomRent') }}</span>
      <span v-if="rentInfo.sqft">{{$formatMoney(rentInfo.sqft)}} Sq.Ft</span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    info: Object,
    img: { type: String, default: '' },
  },
  data() {
    return {
      rentInfo: this.info,
    }
  },
  computed: {
    rentStatus() {
      if (this.rentInfo.rentType === 'entire') return 1 // 整套出租
      if (this.rentInfo.rentType === 'masterBedroom' || this.rentInfo.rentType === 'secondaryBedroom') return 2 // 主卧出租
      if (this.rentInfo.rentType === 'privateRoom') return 3 // 可整租可分租
      return 0
    }
  },
  filters: {
    currencySymbol(name) {
      const map = {
        USD: '$',
        RMB: '￥',
      }
      return map[name] || name
    },
    periodShort(name) {
      const map = {
        week: 'Per Week',
        month: 'Per Month',
        quarter: 'Per Quarter',
        year: 'Per Year',
      }
      return map[name] || name
    },
  },
  methods: {
    goDetail() {
      window.open(`/rent/detail/${this.info.uniqueTitle}`)
    },
    getPrice(item) {
      if (item.price) {
        return item.price
      }
      return 0
    },
    getPriceCurrency(item) {
      if (item.currency) {
        if (item.currency === 'RMB') {
          return {
            decimal: ',',
            thousands: ',',
            prefix: '￥ ',
            precision: 0,
            masked: false,
          }
        }
      }
      return {
        decimal: ',',
        thousands: ',',
        prefix: '$ ',
        precision: 0,
        masked: false,
      }
    },
  },
  watch: {
    info(val) {
      this.rentInfo = val || {}
    },
  },
}

</script>
<style lang="less" scoped>
.item-rent {
  width: 46%;
  height: 328px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease-in;
  padding: 8px 12px;
  margin-bottom: 36px;

  &:hover {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.16);
  }

  .img {
    position: relative;
    height: 180px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.08);
    // background-image:url('../../assets/images/placeholder.png');
  }


  .price {
    margin-top: 10px;
    color: #99d20d;
    font-size: 18px;
    color: #99d20d;
  }


  .price.smalltext {
    font-size: 14px;
    margin-top: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .price>span {
    padding-right: 4px;
    margin-right: 2px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }

  .price>span:last-of-type {
    padding-right: 0;
    margin-right: 0;
    border-right: none;
  }

  .name {
    font-size: 18px;
    height: 50px;
    margin-top: 10px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 14px;
  }

  .detail {
    color: rgba(0, 0, 0, 0.5);

    >span {
      margin-right: 3px;
      padding-right: 1px;

      &:after {
        content: '·';
        padding-left: 3px;
      }

      &:last-child {
        &:after {
          content: ''
        }
      }
    }
  }

  .addr {
    color: rgba(0, 0, 0, 0.5);
    margin-top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: -0.04em;
  }

}

</style>
